/**
 * The NoorView card in the middle of the TV: NoorView at the top, then what's happening. Shown when someone opens
 * NoorView on the TV ("Getting ready", with a spinner) and when the TV is paired (a green tick, the screen's name and
 * the masjid). Light follows the Light theme; otherwise the Legacy look. The TV app shows the same card while it starts
 * (apps/android/app/src/main/res/drawable-nodpi/boot_card.png), so keep them alike.
 */
export function BootCard({ line, title, sub, loading, out }: { line: string; title?: string; sub?: string; loading?: boolean; out?: boolean }) {
  const heading = title ?? (loading ? 'Getting ready' : line);
  return (
    <div className={`boot${out ? ' out' : ''}`} role="status" aria-label={title ? `${line}: ${title}` : `NoorView ${line.toLowerCase()}`}>
      <div className="boot-card">
        <div className="boot-top">
          <img className="boot-logo" src={`${import.meta.env.BASE_URL}noorview-logo.png`} alt="" />
          <h1 className="boot-name"><span>Noor</span><b>View</b></h1>
        </div>
        <div className="boot-sep" />
        <div className="boot-row">
          {loading ? <span className="boot-spin" aria-hidden />
            : <span className="boot-tick" aria-hidden><svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg></span>}
          <div>
            <p className="boot-title">{heading}</p>
            <p className="boot-sub">{loading ? 'Loading your screen' : <><b>{line}</b>{sub ? ` · ${sub}` : ''}</>}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
